/* Emmafy BOGO buy box — offer switch, swatch sync, batch add to cart (offer + ticked upsells), robust drawer */
(function () {
  'use strict';

  var ROOT_PATH = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addToCart(items) {
    return fetch(ROOT_PATH + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || (data.status && data.status !== 200)) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }
        return data;
      });
    });
  }

  function wireDrawerClose(drawerEl) {
    var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.dataset.emWired) {
      overlay.dataset.emWired = '1';
      overlay.addEventListener('click', function () { closeDrawer(drawerEl); });
    }
    var closeBtn = drawerEl.querySelector('.drawer__close');
    if (closeBtn && !closeBtn.dataset.emWired) {
      closeBtn.dataset.emWired = '1';
      closeBtn.addEventListener('click', function () { closeDrawer(drawerEl); });
    }
    if (!drawerEl.dataset.emEscWired) {
      drawerEl.dataset.emEscWired = '1';
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' && drawerEl.classList.contains('active')) closeDrawer(drawerEl);
      });
    }
  }

  function closeDrawer(drawerEl) {
    if (typeof drawerEl.close === 'function') {
      drawerEl.close();
    } else {
      drawerEl.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  function refreshAndOpenDrawer() {
    return fetch(ROOT_PATH + '?sections=cart-drawer,cart-icon-bubble&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');
        if (!drawerEl || !sections['cart-drawer']) throw new Error('no drawer');

        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        var freshInner = tmp.querySelector('#CartDrawer');
        var curInner = drawerEl.querySelector('#CartDrawer');
        if (freshInner && curInner) {
          curInner.innerHTML = freshInner.innerHTML;
        } else if (freshInner) {
          drawerEl.innerHTML = freshInner.outerHTML;
        } else {
          throw new Error('no #CartDrawer in section');
        }
        drawerEl.classList.remove('is-empty');

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var t2 = document.createElement('div');
          t2.innerHTML = sections['cart-icon-bubble'];
          var freshBubble = t2.querySelector('.shopify-section');
          bubble.innerHTML = freshBubble ? freshBubble.innerHTML : sections['cart-icon-bubble'];
        }

        if (typeof drawerEl.open === 'function') {
          drawerEl.open();
        } else {
          document.body.classList.add('overflow-hidden');
          drawerEl.classList.add('animate', 'active');
        }
        wireDrawerClose(drawerEl);
      });
  }

  function afterAdd() {
    return refreshAndOpenDrawer().catch(function () {
      window.location.href = ROOT_PATH + 'cart';
    });
  }

  function setBusy(btn, busy) {
    btn.disabled = busy;
    var spinner = btn.querySelector('.em-bogo__atc-spinner');
    if (spinner) spinner.hidden = !busy;
  }

  /* Image-swatch custom dropdown replacing the native color <select> */
  function closeAllDd(except) {
    document.querySelectorAll('.em-dd.is-open').forEach(function (d) {
      if (d !== except) {
        d.classList.remove('is-open');
        var l = d.querySelector('.em-dd__list');
        if (l) l.hidden = true;
        var b = d.querySelector('.em-dd__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.em-dd')) closeAllDd(null);
  });

  /* Solid color dots — average color sampled from the variant image's bag body */
  var emColorCache = {};
  function emSetDotColor(url, el) {
    if (!url) return;
    if (emColorCache[url]) { el.style.background = emColorCache[url]; return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var S = 24;
        var c = document.createElement('canvas');
        c.width = S; c.height = S;
        var x = c.getContext('2d');
        x.drawImage(im, im.width * 0.3, im.height * 0.48, im.width * 0.4, im.height * 0.34, 0, 0, S, S);
        var d = x.getImageData(0, 0, S, S).data;
        var px = [], lum = [];
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] > 200) {
            px.push([d[i], d[i + 1], d[i + 2]]);
            lum.push(0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]);
          }
        }
        if (!px.length) return;
        var sorted = lum.slice().sort(function (a, b) { return a - b; });
        var med = sorted[Math.floor(sorted.length / 2)];
        var lo = [0, 0, 0, 0], hi = [0, 0, 0, 0];
        px.forEach(function (p, j) {
          var t = lum[j] <= med ? lo : hi;
          t[0] += p[0]; t[1] += p[1]; t[2] += p[2]; t[3]++;
        });
        function rgb(t) { return 'rgb(' + Math.round(t[0] / t[3]) + ',' + Math.round(t[1] / t[3]) + ',' + Math.round(t[2] / t[3]) + ')'; }
        var bg;
        if (lo[3] && hi[3]) {
          var meanLo = (lo[0] + lo[1] + lo[2]) / (3 * lo[3]);
          var meanHi = (hi[0] + hi[1] + hi[2]) / (3 * hi[3]);
          if (meanHi - meanLo > 30) {
            /* two-tone print — Emmafy-style quarter circle */
            bg = 'conic-gradient(' + rgb(lo) + ' 0 25%, ' + rgb(hi) + ' 25% 50%, ' + rgb(lo) + ' 50% 75%, ' + rgb(hi) + ' 75% 100%)';
          }
        }
        if (!bg) {
          var all = [lo[0] + hi[0], lo[1] + hi[1], lo[2] + hi[2], lo[3] + hi[3]];
          bg = rgb(all);
        }
        emColorCache[url] = bg;
        el.style.background = bg;
      } catch (e) { /* CORS-tainted canvas — keep neutral dot */ }
    };
    im.src = url;
  }

  /* Jump the product gallery to the selected variant's photo (Emmafy behavior) */
  function jumpToMedia(mediaId) {
    if (!mediaId) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var el = gallery.querySelector('[data-media-id$="-' + mediaId + '"]');
    if (!el) return;
    if (typeof gallery.setActiveMedia === 'function') {
      try { gallery.setActiveMedia(el.dataset.mediaId, true); return; } catch (e) {}
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function enhanceSelect(sel) {
    if (sel.dataset.emDd) return;
    sel.dataset.emDd = '1';
    var row = sel.parentElement;

    var dd = document.createElement('div');
    dd.className = 'em-dd';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'em-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var bDot = document.createElement('span');
    bDot.className = 'em-dd__dot';
    var bLabel = document.createElement('span');
    bLabel.className = 'em-dd__label';
    var bCaret = document.createElement('span');
    bCaret.className = 'em-dd__caret';
    btn.appendChild(bDot); btn.appendChild(bLabel); btn.appendChild(bCaret);

    var list = document.createElement('ul');
    list.className = 'em-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    Array.prototype.forEach.call(sel.options, function (opt, i) {
      var li = document.createElement('li');
      li.className = 'em-dd__opt' + (opt.disabled ? ' is-disabled' : '');
      li.setAttribute('role', 'option');
      li.dataset.index = i;
      var dot = document.createElement('span');
      dot.className = 'em-dd__dot';
      emSetDotColor(opt.dataset.img, dot);
      var span = document.createElement('span');
      span.textContent = opt.text;
      li.appendChild(dot); li.appendChild(span);
      if (!opt.disabled) {
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change'));
          closeAllDd(null);
          jumpToMedia(opt.dataset.media);
        });
      }
      list.appendChild(li);
    });

    function sync() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      bLabel.textContent = opt.text;
      emSetDotColor(opt.dataset.img, bDot);
      list.querySelectorAll('.em-dd__opt').forEach(function (li) {
        li.classList.toggle('is-active', parseInt(li.dataset.index, 10) === sel.selectedIndex);
      });
    }
    sel.addEventListener('change', sync);
    sync();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var opening = list.hidden;
      closeAllDd(dd);
      list.hidden = !opening;
      dd.classList.toggle('is-open', opening);
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        dd.classList.remove('em-dd--up');
        var r = list.getBoundingClientRect();
        if (r.bottom > window.innerHeight - 12) dd.classList.add('em-dd--up');
        var active = list.querySelector('.em-dd__opt.is-active');
        if (active) active.scrollIntoView({ block: 'nearest' });
      }
    });

    dd.appendChild(btn);
    dd.appendChild(list);
    sel.insertAdjacentElement('afterend', dd);
    if (row && row.classList.contains('em-bogo__color-row')) row.classList.add('has-dd');
  }

  function init(root) {
    if (root.dataset.emInit) return;
    root.dataset.emInit = '1';

    var offers = root.querySelectorAll('.em-bogo__offer');
    offers.forEach(function (offer) {
      var radio = offer.querySelector('.em-bogo__radio');
      radio.addEventListener('change', function () {
        offers.forEach(function (o) { o.classList.toggle('is-selected', o === offer); });
      });
      offer.addEventListener('click', function () {
        if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
      });
    });

    root.querySelectorAll('.em-bogo__select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var img = sel.parentElement.querySelector('.em-bogo__swatch');
        var opt = sel.options[sel.selectedIndex];
        if (img && opt && opt.dataset.img) img.src = opt.dataset.img;
      });
      if (sel.dataset.slot === '2b' && sel.options.length > 1) {
        sel.selectedIndex = 1;
        sel.dispatchEvent(new Event('change'));
      }
      enhanceSelect(sel);
    });

    /* Upsells — tick to include with ADD TO CART (no cart call, no ATC visual) */
    root.querySelectorAll('[data-addon]').forEach(function (row) {
      var btn = row.querySelector('.em-bogo__addon-add');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        btn.textContent = pressed ? '+' : '✓';
      });
    });

    var atc = root.querySelector('[data-em-atc]');
    if (!atc) return;
    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      var selectedOffer = root.querySelector('.em-bogo__offer.is-selected');
      var offerNum = selectedOffer ? selectedOffer.dataset.offer : '2';
      var items = [];

      function pushVariant(id) {
        if (!id) return;
        var found = null;
        for (var i = 0; i < items.length; i++) if (items[i].id === id) found = items[i];
        if (found) found.quantity += 1; else items.push({ id: id, quantity: 1 });
      }

      if (offerNum === '1') {
        pushVariant(parseInt(root.querySelector('[data-slot="1"]').value, 10));
      } else {
        pushVariant(parseInt(root.querySelector('[data-slot="2a"]').value, 10));
        pushVariant(parseInt(root.querySelector('[data-slot="2b"]').value, 10));
      }

      /* ticked upsells ride along */
      root.querySelectorAll('[data-addon]').forEach(function (row) {
        var btn = row.querySelector('.em-bogo__addon-add');
        if (btn.getAttribute('aria-pressed') !== 'true') return;
        var sel = row.querySelector('.em-bogo__addon-select');
        var hidden = row.querySelector('.em-bogo__addon-single');
        pushVariant(parseInt(sel ? sel.value : hidden.value, 10));
      });

      if (!items.length) return;

      setBusy(atc, true);
      addToCart(items)
        .then(afterAdd)
        .catch(function () { window.location.href = ROOT_PATH + 'cart'; })
        .finally(function () { setBusy(atc, false); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-em-bogo]').forEach(init);
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) wireDrawerClose(drawerEl);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
